import apiClient from '@/scripts/api/apiClient';

/**
 * Comment API endpoints
 */

// Query key factories
export const commentKeys = {
  getComment: (commentId) => ['get', 'comments', commentId],
  createReply: (commentId) => ['create', 'comments', commentId, 'replies'],
  updateComment: (commentId) => ['update', 'comments', commentId],
  deleteComment: (commentId) => ['delete', 'comments', commentId],
};

/**
 * Get a specific comment by ID
 * @param {string} commentId - Comment ID
 * @returns {Promise<Object>} Comment details
 */
export const getComment = async (commentId) => {
  const response = await apiClient.get(`/api/comments/${commentId}`);
  return response.data;
};

/**
 * Create a reply to an existing comment
 * @param {string} parentId - Parent comment ID
 * @param {Object} replyData - Reply data with text
 * @returns {Promise<Object>} Created reply
 */
export const createReply = async (parentId, replyData) => {
  const response = await apiClient.post(`/api/comments/${parentId}/replies`, replyData);
  return response.data;
};

/**
 * Update a comment
 * @param {string} commentId - Comment ID
 * @param {Object} commentData - Comment data to update
 * @returns {Promise<Object>} Updated comment
 */
export const updateComment = async (commentId, commentData) => {
  const response = await apiClient.put(`/api/comments/${commentId}`, commentData);
  return response.data;
};

/**
 * Delete a comment
 * @param {string} commentId - Comment ID
 * @returns {Promise<Object>} Response data
 */
export const deleteComment = async (commentId) => {
  const response = await apiClient.delete(`/api/comments/${commentId}`);
  return response.data;
};
